// The web sends the Appwrite session as a cookie: without `include`, a
// cross-origin download goes out anonymous and the private bucket answers 401.
export const webFetchFile = (url: string): Promise<Response> =>
	fetch(url, { credentials: "include" });
